import moment, { Moment } from 'moment'

/** Atraso tolerado sem justificativa na abertura da sessão (PC-02, decisão de 10/10/2026) — o mesmo do servidor. */
export const SESSION_OPENING_LATE_TOLERANCE_MINUTES = 15

export interface SessionOpeningCheck {
	/** Antes do horário de abertura do edital: a abertura é recusada. */
	early: boolean
	/** Mais de 15 minutos depois do horário: a abertura pede justificativa, que vai para a ata. */
	late: boolean
	/** Horário do edital para a mensagem ("15/10/2026 às 15:00"), ou nulo sem horário. */
	scheduledLabel: string | null
}

/**
 * Horário da primeira abertura da sessão (PC-02 e DSP-G02): espelho da `NoticeSessionOpeningSchedule` do servidor, que
 * é quem decide. Na sessão, `closedDate`/`closedTime` guardam a data e a hora de abertura do edital.
 */
export function sessionOpeningCheck(closedDate: string | null | undefined, closedTime: string | null | undefined, now: Moment = moment()): SessionOpeningCheck {
	if (!closedDate || !closedTime) return { early: false, late: false, scheduledLabel: null }

	const scheduledAt = moment(`${closedDate} ${closedTime}`, 'YYYY-MM-DD HH:mm:ss')
	if (!scheduledAt.isValid()) return { early: false, late: false, scheduledLabel: null }

	return {
		early: now.isBefore(scheduledAt),
		late: now.isAfter(scheduledAt.clone().add(SESSION_OPENING_LATE_TOLERANCE_MINUTES, 'minutes')),
		scheduledLabel: scheduledAt.format('DD/MM/YYYY [às] HH:mm')
	}
}
